
/**
 * props.api[string] 上传接口(选填，默认: /tool/upload)
 * props.imageKey[string] 后端定位图片的key(选填，一般用于后端裁剪图片)
 * props.width[number] 裁剪宽度(选填，但是必须和height成对存在)
 * props.height[number] 裁剪高度(选填，但是必须和width成对存在)
 * props.size[number] 大小限制(选填，单位是K)
 * props.ratio[number|boject] 原图片宽高比(选填, 该字段与height、width互斥, 若同时存在, 该配置优先。 例如 3.0 或 { min: 0.3, max: 3.0 })
 * props.accept[string] 上传文件格式，默认: image/*,.jpg,.jpeg,.png,.gif
 * props.value[string|object] 图片url(选填，相当于Input的value), 当是一个对象时是{path: 相对路径,ossUrl: 显示路径},这种情况用于向后端传的和显示的地址不一样
 * props.onChange[fn] 上传完成的回调(必填，相当于Input的onChange。因为上传后会丢失原文件名，所以返回值对象中附加一原文件名属性fileName，万一需要呢)
 * props.originUrl[tring] 原图url(选填)
 * props.originName[tring] 原图名称(选填)
 * props.allowDownload[bool] 是否可以下载原图(默认false，需要originUrl)
 * props.allowEdit[bool] 是否可以重新裁剪图片(默认false，需要originUrl、width、height)
 * props.allowOverload[bool] 是否可以重新上传图片(默认true)
 * props.allowClear[bool] 是否可以删除图片(默认true)
 **/

import React from 'react';
import ReactAvatarEditor from 'react-avatar-editor';
import { Button, Modal, Slider, Tooltip, Spin, Icon ,message} from 'antd';
import lodash from 'lodash';
import http from 'libs/http';
import './index.less';

class UploadImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCorpModal: false,
      originFile: null,
      corpScale: 1,
      uploading: false,
      fileName: ''
    }
  }

  //选择图片
  chooseImage = (e) => {
    console.log(e,'111')
    const file = document.createElement('input');
    file.type = 'file';
    file.accept = this.props.accept || "image/*,.jpg,.jpeg,.png,.gif";
    file.style.display = 'none';
    document.body.appendChild(file);
    file.click();
    file.onchange = (event) => {
      const selectedFile = event.target.files[0];
      // console.log(/image\/(gif|jpg|jpeg|png)$/i.test(selectedFile.type),'11111111')
      // 判断文件类型，若不是图片，进行提示
      if(!/image\/(gif|jpg|jpeg|png)$/i.test(selectedFile.type)){
        message.error('文件类型不符合要求，已被拦截');
        return 
      }
      const dataSize = Math.round(selectedFile.size / 1000);
      this.setState({ fileName: selectedFile.name });
      document.body.removeChild(file);
      const reader = new FileReader();
      reader.onload = () => {
        const base64Data = reader.result;
        this.checkImage(base64Data, dataSize, selectedFile);
      };
      reader.readAsDataURL(selectedFile);
    };
  }

  //判断图片大小,尺寸,宽高比率
  checkImage = (base64Data, dataSize, file) => {
    const { size, ratio, width, height } = this.props;
    const image = new Image();
    image.onload = () => {
      const { width: imgWidth, height: imgHeight } = image;
      const imgRatio = (imgWidth / imgHeight).toFixed(1);
      const needCorp = !ratio && width && height && (width !== imgWidth || height !== imgHeight);
      if (size && dataSize > size) {
        Modal.error({
          title: '上传失败',
          content: (
            <p>
              你选择的图片大于{size}K，已超出限制。
              可到图片压缩网站（
              <a
                href="https://tinypng.com/"
                rel="noopener noreferrer"
                target="_blank"
              >https://tinypng.com</a>
              ）进行压缩
            </p>
          )
        });
      } else if (needCorp) {
        this.setState({
          showCorpModal: true,
          originFile: base64Data
        });
      } else if (typeof ratio === "number" && imgRatio !== ratio) {
        Modal.error({
          title: '上传失败',
          content: `所选图片的宽高比[${imgRatio}]和设定的宽高比[${ratio}]不匹配，无法上传。`
        });
      } else if (typeof ratio === "object" && (imgRatio < ratio.min || imgRatio > ratio.max)) {
        Modal.error({
          title: '上传失败',
          content: `所选图片的宽高比[${imgRatio}]和设定的宽高比范围[${ratio.min}-${ratio.max}]不匹配，无法上传。`
        });
      } else {
        this.startUpload(file);
      }
    };
    image.src = base64Data;
  }

  //重新裁剪图片
  editImage = (originUrl) => {
    this.setState({
      originFile: originUrl,
      showCorpModal: true,
      fileName: this.props.originName || `${new Date().getTime()}.png`
    });
  }

  //取得裁剪后的图像
  getCavasBlob = () => {
    let MIMEType = 'image/png';
    if (this.state.fileName.match(/\.(jpe?g|gif|bmp|png)$/)) {
      MIMEType = 'image/' + RegExp.$1.replace('jpg', 'jpeg')
    }
    const base64Data = this.avatarEditor.getImageScaledToCanvas().toDataURL(MIMEType)
    fetch(base64Data)
    .then(res => res.blob())
    .then(blob => {
      this.setState({
        showCorpModal: false,
        originFile: null,
        corpScale: 1
      });
      this.startUpload(blob);
    });
  }

  //上传
  startUpload = file => {
    const formData = new FormData();
    const { fileName } = this.state;
    if (this.props.imageKey) {
      formData.append('param.imageFile', file, fileName);
      formData.append('param.imageKey', this.props.imageKey);
    } else {
      formData.append('param.file', file, fileName);
    }
    if (this.props.addPersist) {
      formData.append('param.persist', 'true');
    }
    this.setState({ uploading: true });
    http.upload(this.props.api || '/tool/upload', formData)
    .then(res => {
      if (typeof res === 'object') {
        res.fileName = fileName;
      }
      this.setState({ uploading: false });
      this.props.onChange(res);
    })
    .catch(() => this.setState({ uploading: false }));
  }

  render() {
    const {
      value,
      originUrl,
      width,
      height,
      allowDownload,
      allowEdit,
      allowOverload = true,
      allowClear = true,
      className = '',
      isShowIcon = true
    } = this.props;
    const {
      showCorpModal,
      originFile,
      corpScale,
      uploading
    } = this.state;

    //裁剪外框尺寸
    const corpSize = {
      width: 560,
      height: 260
    };

    //图片缩放初始值
    let scale = 1;
    let borderY = 0;
    let borderX = 0;

    if (width && height && width / height > corpSize.width / corpSize.height) {
      scale = corpSize.width / width;
      borderY = (corpSize.height / scale - height) / 2;
    } else if (width && height) {
      scale = corpSize.height / height;
      borderX = (corpSize.width / scale - width) / 2;
    }

    let hasValue = !lodash.isEmpty(value);
    if (hasValue && typeof value === 'object' && !value.path && !value.fileKey) {
      hasValue = false;
    }

    let picUrl = `http://via.placeholder.com/${width || 100 }x${height || 100}`;
    if (hasValue && typeof value === 'string') {
      picUrl = value;
    } else if (hasValue && typeof value === 'object' && (value.ossUrl || value.fileUrl)) {
      picUrl = value.ossUrl || value.fileUrl;
    }

    return (
      <div className={`kr-upload-image ${className}`}>
        {!hasValue &&
          <Spin spinning={uploading}>
            <div
              className="add-image-btn"
              onClick={(e)=>{this.chooseImage(e)}}
            >{isShowIcon&&
              <Icon type="plus" />
            }
            </div>
          </Spin>
        }
        {hasValue &&
          <div className="pic-wrapper">
            <a
              href={picUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={picUrl} alt="" title="查看图片" />
            </a>
          </div>
        }
        {hasValue &&
          <div className="upload-options">
            <Button.Group>
              {allowOverload && <Tooltip
                placement="bottom"
                overlayStyle={{ fontSize: 12 }}
                title="重新上传"
              >
                <Button
                  icon="cloud-upload"
                  size="small"
                  loading={uploading}
                  onClick={this.chooseImage}
                />
              </Tooltip>}
              {allowEdit && originUrl && width && height &&
                <Tooltip
                  placement="bottom"
                  overlayStyle={{ fontSize: 12 }}
                  title="编辑原图"
                >
                  <Button
                    icon="edit"
                    size="small"
                    onClick={() => this.editImage(originUrl)}
                  />
                </Tooltip>
              }
              {allowDownload && originUrl &&
                <Tooltip
                  placement="bottom"
                  overlayStyle={{ fontSize: 12 }}
                  title="下载原图"
                >
                  <Button
                    icon="download"
                    size="small"
                    target="_blank"
                    href={originUrl}
                  />
                </Tooltip>
              }
              {allowClear && value &&
                <Tooltip
                  placement="bottom"
                  overlayStyle={{ fontSize: 12 }}
                  title="删除图片"
                >
                  <Button
                    icon="delete"
                    size="small"
                    onClick={() => this.props.onChange()}
                  />
                </Tooltip>
              }
            </Button.Group>
          </div>
        }
        {/* 裁剪图片框 */}
        <Modal
          className="image-corp-modal"
          title="裁剪图片"
          maskClosable={false}
          width={corpSize.width + 48}
          visible={showCorpModal}
          onCancel={() => {
            this.setState({
              showCorpModal: false,
              originFile: null,
              corpScale: 1
            });
          }}
          onOk={this.getCavasBlob}
        >
          <div
            className="image-corp-wrapper"
            style={{
              width: corpSize.width,
              height: corpSize.height
            }}
          >
            <ReactAvatarEditor
              ref={ele => this.avatarEditor = ele}
              style={{ transform: `scale(${scale})` }}
              image={originFile}
              width={width}
              height={height}
              scale={corpScale}
              border={[borderX, borderY]}
              color={[0, 0, 0, 0.6]}
              crossOrigin="anonymous"
            />
          </div>
          <div className="image-corp-slider">
            <span className="corp-slider-label">缩放：</span>
            <Slider
              className="corp-slider"
              min={1}
              max={10}
              step={0.02}
              marks={{ 1: '1', 10: '10'}}
              value={corpScale}
              onChange={val => this.setState({ corpScale: val })}
            />
          </div>
        </Modal>
      </div>
    );
  }
}

export default UploadImage;
